import { getCustomPanelList, getCustomPanelListWTubeInfos } from "@/utils/va-order-test/best-deal-extract/helpers.js";
import { parseJson } from "@/utils";

const panels = {
  namespaced: true,
  state: {
    discountPanelList: [],
    discountPanelFilterTagList: [],
    customPanelList: [],
    serumDiscountPanelList: [],
    dbsDiscountPanelList: [],
    selectedCustomPanelIdList: [],
    selectedDiscountPanelIdList: [],
    selectedXChooseYPanelIdList: []
  },
  getters: {
    bundleList(state) {
      return state.customPanelList.concat(state.discountPanelList);
    },
    selectedDiscountPanelCount(state) {
      return state.discountPanelList.filter(panel => panel.isSelect).length;
    },
    selectedCustomPanelList(state) {
      return state.customPanelList.filter(panel => state.selectedCustomPanelIdList.includes(panel.bundleId));
    },
    selectedDiscountPanelList(state) {
      return state.discountPanelList.filter(panel => state.selectedDiscountPanelIdList.includes(panel.bundleId));
    },
    selectedXChooseYPanelList(state) {
      return state.discountPanelList.filter(panel => state.selectedXChooseYPanelIdList.includes(panel.bundleId));
    },
    nonOrderableDiscountPanelIds(state) {
      return state.discountPanelList.filter(panel => panel.toBeOffline).map(panel => panel.bundleId);
    }
  },
  mutations: {
    SET_DISCOUNT_PANEL_LIST(state, discountPanelList) {
      state.discountPanelList = discountPanelList;
    },
    SET_CUSTOM_PANEL_LIST(state, customPanels) {
      state.customPanelList = customPanels;
    },
    SET_SERUM_DISCOUNT_PANEL_LIST(state, serumList) {
      state.serumDiscountPanelList = serumList;
    },
    SET_DBS_DISCOUNT_PANEL_LIST(state, dbsList) {
      state.dbsDiscountPanelList = dbsList;
    },
    ADD_DBS_DISCOUNT_PANEL(state, dbsDiscountPanel) {
      state.dbsDiscountPanelList.push(dbsDiscountPanel);
    },
    SET_DISCOUNT_PANEL_FILTER_TAG_LIST(state, tagList) {
      state.discountPanelFilterTagList = tagList;
    }
  },
  actions: {
    setDiscountPanelList({ commit }, discountPanelList) {
      commit("SET_DISCOUNT_PANEL_LIST", discountPanelList);
    },

    async setCustomPanelList({ commit, rootState }) {
      try {
        let userInfo = rootState.orderTest.user.userInfo;
        let customer = rootState.orderTest.user.customer;
        let { customer_id, clinic_id, isClinic, user_roles } = userInfo;
        // Derive isClinic from user_roles if not present
        const isClinicValue = isClinic !== undefined ? isClinic : (user_roles && user_roles.includes("clinic"));

        // For clinic users, use the selected customer's ID instead of the clinic's customer_id
        let actualCustomerId = customer_id;
        if (isClinicValue && customer && customer.id) {
          actualCustomerId = customer.id;
        }

        let currency = parseJson(localStorage.getItem("currency"));
        let payload = {
          currency: currency.name ? currency.name.toLowerCase() : "usd",
          customerId: actualCustomerId,
          clinicId: clinic_id,
          accountType: isClinicValue ? "clinic" : "customer"
        }
        let customPanelList = await getCustomPanelList(payload);
        commit("SET_CUSTOM_PANEL_LIST", customPanelList);
      } catch (err) {
        console.log("setCustomPanelList err", err);
      }
    },

    async setCustomPanelListWTubrInfo({ commit }) {
      let customPanelList = await getCustomPanelListWTubeInfos();
      commit("SET_CUSTOM_PANEL_LIST", customPanelList);
    },

    setSerumAndDbsDiscountPanelList({ state, commit, rootState }) {
      let serum = state.discountPanelList.filter(panel => ["not_at_home", "both"].includes(panel.section) && !panel.toBeOffline);
      let dbs = state.discountPanelList.filter(panel => ["at_home", "both"].includes(panel.section) && !panel.toBeOffline);
      commit("SET_SERUM_DISCOUNT_PANEL_LIST", serum);
      commit("SET_DBS_DISCOUNT_PANEL_LIST", dbs);
    },

    async setDiscountPanelFilterTagList({ commit }, data) {
      let tagList = data.map((tag, index) => ({
        index,
        names: { ...tag.names, english: tag.name },
        bundleIdList: tag.bundleIds,
        isSelect: false,
      }));
      commit("SET_DISCOUNT_PANEL_FILTER_TAG_LIST", tagList);
    },

    addDbsDiscountPanel({ commit }, dbsDiscountPanel) {
      commit("ADD_DBS_DISCOUNT_PANEL", dbsDiscountPanel);
    }
  }
};

export default panels;